import { useState } from 'react';

const SUBMIT_URL = 'https://readdy.ai/api/form/da2m0eiamq5jpe1hs0bg';

export default function Contact() {
  const [formError, setFormError] = useState('');
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setFormError('');
    setSuccess(false);

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = String(formData.get('website_alt') || '').trim();
    if (honeypot) {
      setSuccess(true);
      form.reset();
      return;
    }
    if (honeypot === '') {
      formData.delete('website_alt');
    }

    try {
      const res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || responseText;
      if (!res.ok || parsed?.code !== 'OK' || /spam/i.test(serverMsg || '')) {
        setFormError(serverMsg || '提交失败，请稍后重试。');
        return;
      }
      setSuccess(true);
      form.reset();
    } catch {
      setFormError('网络异常，请稍后重试。');
    }
  }

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-block rounded-full bg-secondary-100 px-4 py-1.5 text-sm text-secondary-800">
              联系我们
            </span>
            <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              有想了解的角色或建议？告诉我们
            </h2>
            <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
              如果你对泡在我家的辣妹某个角色、某条人物关系有疑问，或想补充你喜欢的角色资料，欢迎留言，我们会持续完善内容。
            </p>

            <ul className="mt-8 flex flex-col gap-4">
              <li className="flex items-center gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-950">意见与建议</div>
                  <div className="text-sm text-foreground-600">hello@galsite.example.com</div>
                </div>
              </li>
              <li className="flex items-center gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className="ri-chat-smile-line text-lg"></i>
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-950">官方平台</div>
                  <div className="text-sm text-foreground-600">以作品官方发布渠道为准</div>
                </div>
              </li>
            </ul>
          </div>

          <form
            onSubmit={handleSubmit}
            data-readdy-form="泡在我家的辣妹联系表单"
            className="rounded-3xl border border-background-200 bg-background-100 p-6 md:p-8"
          >
            <h3 className="font-heading text-xl text-foreground-950">给我们留言</h3>

            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div className="flex flex-col gap-1.5">
                <label htmlFor="name" className="text-sm text-foreground-800">
                  你的称呼
                </label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  required
                  placeholder="怎么称呼你"
                  className="rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
              </div>
              <div className="flex flex-col gap-1.5">
                <label htmlFor="email" className="text-sm text-foreground-800">
                  邮箱
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  placeholder="you@example.com"
                  className="rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
              </div>
            </div>

            <div className="mt-4 flex flex-col gap-1.5">
              <label htmlFor="topic" className="text-sm text-foreground-800">
                留言主题
              </label>
              <select
                id="topic"
                name="topic"
                className="rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              >
                <option value="角色补充">角色补充</option>
                <option value="人物关系疑问">人物关系疑问</option>
                <option value="内容建议">内容建议</option>
                <option value="其他">其他</option>
              </select>
            </div>

            <div className="mt-4 flex flex-col gap-1.5">
              <label htmlFor="message" className="text-sm text-foreground-800">
                留言内容
              </label>
              <textarea
                id="message"
                name="message"
                required
                maxLength={500}
                rows={4}
                placeholder="想说什么都可以告诉我们"
                className="rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
              ></textarea>
              <p className="text-right text-xs text-foreground-600">最多 500 字</p>
            </div>

            <input
              type="text"
              name="website_alt"
              className="honeypot-guard"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />

            {formError && (
              <p className="mt-4 rounded-lg bg-primary-100 px-4 py-2.5 text-sm text-primary-700">
                {formError}
              </p>
            )}
            {success && (
              <p className="mt-4 rounded-lg bg-accent-100 px-4 py-2.5 text-sm text-accent-700">
                感谢你的留言，我们会认真阅读每一条建议！
              </p>
            )}

            <button
              type="submit"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              提交留言
              <i className="ri-send-plane-line"></i>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}